export const getMixpanelLabelForReportType = (reportType?: string) => {
  switch (reportType) {
    case 'maintenance_coverage':
      return 'maintenance_coverage';
    case 'credit_report':
      return 'credit_rating';
    case 'initiation_coverage':
      return 'initiation_coverage';
    case 'open_research':
      return 'custom_research';
    case 'drhp_report':
      return 'drhp_report';
    default:
      return 'unknown_report_type';
  }
};
